import React from "react";
import { Link } from "react-router-dom";
import { formatNewsDateShort, PILLAR_DOT } from "../data/newsArticles";

const NewsArticleCard = ({ article, variant = "default" }) => {
  const featured = variant === "featured";
  const dot = PILLAR_DOT[article.pillarPrimary] || "bg-lime";

  return (
    <Link
      to={`/news/${article.slug}`}
      className={`group block border border-mandrogni/30 hover:border-lime transition-colors duration-300 p-6 md:p-7 h-full flex flex-col ${featured ? "bg-galactico" : "bg-galactico"}`}
      data-hover="true"
      data-testid={`news-card-${article.slug}`}
    >
      <div className="flex items-center gap-2">
        <span
          className={`inline-block w-2 h-2 rounded-full ${dot}`}
          aria-hidden="true"
        />
        <span className="font-condensed uppercase tracking-widest text-lime text-[11px]">
          {article.rubric}
        </span>
      </div>
      <h3
        className={`mt-3 font-display leading-[1.05] text-dodgers group-hover:text-lime transition-colors ${featured ? "text-[28px] md:text-[40px]" : "text-[22px] md:text-[26px]"}`}
      >
        {article.title}
      </h3>
      <p
        className="mt-3 text-mandrogni text-[14px] md:text-[15px] leading-[1.55]"
        style={{
          fontFamily: "'Hanken Grotesk', sans-serif",
          display: "-webkit-box",
          WebkitLineClamp: featured ? 3 : 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {article.subtitle}
      </p>
      <div className="mt-auto pt-5 flex flex-wrap items-center gap-x-2 gap-y-1 font-condensed uppercase tracking-widest text-[11px] text-mandrogni">
        <span>{article.author}</span>
        <span className="inline-block w-1 h-1 rounded-full bg-lime" aria-hidden="true" />
        <span>{article.readingTime} min</span>
        <span className="inline-block w-1 h-1 rounded-full bg-lime" aria-hidden="true" />
        <span>{formatNewsDateShort(article.publishedAt)}</span>
      </div>
    </Link>
  );
};

export default NewsArticleCard;
